<nav
  class="navbar bg-black navbar-expand-lg d-none d-lg-flex shadow px-3"
  role="navigation"
  aria-label="Main navigation"
>
  <a
    class="navbar-brand py-0"
    [routerLink]="['/']"
    routerLinkActive="router-link-active"
    attr.aria-label="{{
      'nav.home.page.screenreader'
        | translate : { fgbdefault: 'Move to home page' }
    }}"
  >
    <span class="accessibility-only" id="homeLink">Go To Home Page</span>
    <img
      alt=""
      class="ms-1 h-100"
      aria-labelledby="homeLink"
      [src]="'logos/phxid-logo.svg' | contentAssetImage"
      draggable="false"
    />
  </a>

  <button
    class="navbar-toggler"
    type="button"
    (click)="isCollapsed = !isCollapsed"
    aria-controls="navbarSupportedContent"
    [attr.aria-expanded]="!isCollapsed"
    attr.aria-label="{{ 'nav.toggle.screenreader' | translate }}"
  >
    <span class="navbar-toggler-icon"></span>
  </button>

  <!-- Left Side Content -->
  <div
    class="navbar-collapse flex-grow-1"
    [ngbCollapse]="isCollapsed"
    id="navbarSupportedContent"
  >
    <div class="nav-container">
      <ul class="navbar-nav" #greedyNav role="menubar">
        <li class="nav-item active" role="none">
          <a
            class="nav-link mx-1 nav-bar-link"
            [routerLink]="['/payment']"
            routerLinkActive="router-link-active"
            role="menuitem"
            attr.aria-label="{{
              'nav.phx.pay.screenreader'
                | translate : { fgbdefault: 'Move to PHX Pay page' }
            }}"
            >{{ "nav.phx.pay" | translate }}</a
          >
        </li>
        <li class="nav-item active" role="none">
          <a
            class="nav-link mx-1 nav-bar-link"
            [routerLink]="['/rewards/wallet']"
            routerLinkActive="router-link-active"
            role="menuitem"
            attr.aria-label="{{
              'nav.rewards.screenreader'
                | translate : { fgbdefault: 'Move to rewards page' }
            }}"
            >{{ "nav.rewards" | translate }}</a
          >
        </li>
      </ul>
    </div>

    <!-- Right Side Content -->
    <div
      class="d-flex align-items-center flex-nowrap my-2 my-lg-0 ms-auto gap-3"
      role="toolbar"
      aria-label="Account and balance toolbar"
    >
      <!-- Points Balance -->
      <div
        class="nav-points-pill bg-glass"
        *ngIf="combinedCard$"
        aria-live="polite"
      >
        <span class="material-symbols-outlined" aria-hidden="true"
          >money_bag</span
        >
        <span
          class="fw-bold"
          attr.aria-label="{{ 'nav.ecash.screenreader' | translate }} {{
            combinedCard$ | async | FortressCurrencyPipe
          }}"
          >{{ combinedCard$ | async | FortressCurrencyPipe }}</span
        >
      </div>

      <!-- Menu Toggle Button -->
      <button
        class="nav-link btn d-flex align-items-center px-0 justify-content-end text-white"
        (click)="toggleSideNav()"
        [attr.aria-expanded]="isNavOpen"
        aria-controls="rightNavMenu"
        attr.aria-label="{{
          'nav.account.menu.screenreader'
            | translate
              : {
                  fgbdefault: isNavOpen
                    ? 'Close navigation menu'
                    : 'Open navigation menu'
                }
        }}"
        focusTab
      >
        <i class="material-symbols-outlined" aria-hidden="true">menu</i>
      </button>
    </div>
  </div>
</nav>

<!-- Loading  -->
<ng-template #memberDetailsLoading>
  <div
    class="user-box d-block text-center text-on-primary px-4"
    aria-busy="true"
    aria-label="Loading member details"
  >
    <fgbcl-loading [size]="'small'"></fgbcl-loading>
  </div>
</ng-template>

<!-- Side Nav  -->
<div
  class="right-nav-menu-overlay"
  *ngIf="isNavOpen"
  [@rightMenuOverlayAnimation]
  (click)="isNavOpen = false"
  aria-hidden="true"
></div>

<!-- Side Nav Menu -->
<nav
  id="rightNavMenu"
  class="right-nav-menu"
  [@rightNavAnimation]="isNavOpen ? 'open' : 'close'"
  [ngClass]="{ open: isNavOpen }"
  [attr.aria-hidden]="!isNavOpen"
  aria-label="Side navigation"
  role="navigation"
>
  <div class="d-flex flex-column justify-content-between h-100">
    <div class="d-flex flex-column gap-4">
      <!-- Header: Logo + Close -->
      <div class="d-flex align-items-center justify-content-between">
        <img
          class="side-nav-logo"
          [src]="'logos/phxid-black-logo.svg' | contentAssetImage"
          draggable="false"
          alt="PHX ID logo"
        />
        <button
          class="side-nav-close-btn"
          type="button"
          (click)="isNavOpen = false"
          aria-label="Close navigation menu"
        >
          <span class="material-symbols-outlined" aria-hidden="true"
            >close</span
          >
        </button>
      </div>

      <!-- Member Card -->
      <div
        class="side-nav-member-card"
        *ngIf="memberDetails$ | async as member"
      >
        <div class="d-flex flex-column text-white">
          <p class="fw-bold font-size-18 font-page-heading mb-0">
            {{ member.FirstName }} {{ member.Surname }}
          </p>
          <p class="font-size-14 mb-0" *ngIf="card$ | async as card">
            {{ card.ProductCodeDisplayName }} - {{ card.ExternalRefNumber }}
          </p>
        </div>
        <fgb-payment-button></fgb-payment-button>
      </div>

      <!-- Nav Links -->
      <ul
        class="right-nav-menu-list"
        role="menubar"
        aria-label="Side navigation links"
      >
        <li role="none">
          <a
            class="right-nav-menu-item text-black"
            [routerLink]="['/account']"
            [routerLinkActive]="'active'"
            [routerLinkActiveOptions]="{ exact: true }"
            role="menuitem"
            (click)="isNavOpen = false"
          >
            <div class="nav-text">
              <span class="icon material-icons" aria-hidden="true"
                >account_circle</span
              >
              {{ "nav.profile" | translate }}
            </div>
          </a>
        </li>

        <!-- Help Group -->
        <li role="none">
          <button
            class="right-nav-menu-item right-nav-menu-group text-black w-100 text-start border-0 bg-transparent"
            (click)="isHelpOpen = !isHelpOpen"
            [attr.aria-expanded]="isHelpOpen"
            aria-controls="helpSubmenu"
            attr.aria-label="{{
              isHelpOpen ? 'Collapse help menu' : 'Expand help menu'
            }}"
            role="menuitem"
            aria-haspopup="true"
          >
            <div class="d-flex align-items-center justify-content-between">
              <div class="nav-text">
                <span class="icon material-icons" aria-hidden="true">info</span>
                {{ "nav.help" | translate }}
              </div>
              <i
                class="material-icons help-chevron"
                [class.rotated]="!isHelpOpen"
                aria-hidden="true"
                >expand_more</i
              >
            </div>
          </button>

          <ul
            id="helpSubmenu"
            class="help-submenu list-unstyled"
            *ngIf="!isHelpOpen"
            role="menu"
            aria-label="Help sub-menu"
          >
            <li role="none">
              <a
                class="right-nav-menu-subitem text-black"
                [routerLink]="['/terms']"
                [routerLinkActive]="'active'"
                role="menuitem"
                (click)="isNavOpen = false"
              >
                <div class="nav-text">{{ "nav.terms" | translate }}</div>
              </a>
            </li>
            <li role="none">
              <a
                class="right-nav-menu-subitem text-black"
                [href]="'nav.faqs.url' | translate"
                role="menuitem"
                (click)="isNavOpen = false"
              >
                <div class="nav-text">{{ "nav.faqs" | translate }}</div>
              </a>
            </li>
          </ul>
        </li>
      </ul>
    </div>

    <!-- Logout -->
    <button
      class="log-out bg-transparent"
      (click)="logout()"
      attr.aria-label="{{
        'nav.log.out.screenreader'
          | translate : { fgbdefault: 'Log out of your account' }
      }}"
    >
      <i class="material-icons font-size-14 fw-bold" aria-hidden="true"
        >logout</i
      >
      <div class="nav-text">{{ "nav.log.out" | translate }}</div>
    </button>
  </div>
</nav>
